import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAllApprovalStatusesByCustomerId,
  getAllApprovalCustomers,
  sendCustomerCredentialsThunk,
} from "../thunks/customerThunks";

const initialCustomerState = {
  customers: null,
  selectedCustomerStatuses: null,
  statusesLoading: false,
  showCustomerData: true,
  loading: false,
  error: null,
};

const ApprovalCustomerSlice = createSlice({
  name: "approvalCustomer",
  initialState: initialCustomerState,
  reducers: {
    updateCustomer(state, action) {
      const index = state.customers.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.customers[index] = action.payload;
      }
    },
    addCustomer(state, action) {
      state.customers.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllApprovalCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllApprovalCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload;
      })
      .addCase(getAllApprovalCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch customers";
      })
      .addCase(sendCustomerCredentialsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendCustomerCredentialsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;

        const customerId = action.payload;

        // Update the specific customer's approval status
        if (state.customers) {
          const customerIndex = state.customers.findIndex(
            (customer) => customer.customer_Id === customerId
          );

          if (customerIndex !== -1) {
            state.customers[customerIndex].isMulti_level_approved = 1;
          }
        }
      })
      .addCase(sendCustomerCredentialsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to send credentials.";
      })
      .addCase(fetchAllApprovalStatusesByCustomerId.pending, (state) => {
        state.statusesLoading = true;
        state.selectedCustomerStatuses = null;
      })
      .addCase(fetchAllApprovalStatusesByCustomerId.fulfilled, (state, action) => {
        state.statusesLoading = false;
        state.selectedCustomerStatuses = action.payload;
      })
      .addCase(fetchAllApprovalStatusesByCustomerId.rejected, (state, action) => {
        state.statusesLoading = false;
        state.error = action.payload || "Failed to fetch approval statuses";
      });
  },
});

export const { updateCustomer, addCustomer } = ApprovalCustomerSlice.actions;
export default ApprovalCustomerSlice.reducer;
